export enum EditorScreen {
  UPLOAD = "UPLOAD",
  GENERATE = "GENERATE",
  MAIN = "MAIN",
  PRODUCT_LIFESTYLE = "PRODUCT_LIFESTYLE",
  MODEL_LIFESTYLE = "MODEL_LIFESTYLE",
  MODEL_FACE_SWAP = "MODEL_FACE_SWAP",
  MODEL_GENERATION = "MODEL_GENERATION",
}

export const COVERAGE_AREA_LIST = [100, 90, 80, 70, 60, 50, 40, 30, 20, 10];

export const IMAGE_POSITION_LIST = [
  "Center Center",
  "Right Center",
  "Left Center",
  "Top Right",
  "Top Center",
  "Top Left",
  "Bottom Left",
  "Bottom Right",
  "Bottom Center",
];

export const UPGRADE_VALUE = [
  {
    value: 10,
    label: 10,
  },
  {
    value: 20,
    label: 20,
  },
  {
    value: 30,
    label: 30,
  },
  {
    value: 40,
    label: 40,
  },
  {
    value: 50,
    label: 50,
  },
  {
    value: 60,
    label: 60,
  },
  {
    value: 70,
    label: 70,
  },
  {
    value: 80,
    label: 80,
  },
  {
    value: 90,
    label: 90,
  },
  {
    value: 100,
    label: 100,
  },
];

export const TYPELIST = ["STABLE_DIFFUSION", "IMAGEN"];

export const MODELLIST = ["juggernautXL_v8Rundiffusion.safetensors", "epicphotogasm_ultimateFidelity.safetensors", "realisticStockPhoto_v10.safetensors", "sd_xl_base_1.0_0.9vae.safetensors", "juggernautXL_juggXIByRundiffusion.safetensors","LEOSAM's HelloWorld XL"];

export const REFINERSLIST = ["realisticVisionV60B1_v51VAE.safetensors", "epicphotogasm_ultimateFidelity.safetensors", "sd_xl_refiner_1.0_0.9vae.safetensors"];

export const LORELIST = [
  "Beautiful_outdoor-Countryside.safetensors",
  "Hotel_homestay_indoor_and_outdoor.safetensors",
  "ReaLora.safetensors",
  "sd_xl_offset_example-lora_1.0.safetensors",
  "SDXL_FILM_PHOTOGRAPHY_STYLE_V1.safetensors",
  "simple_background_v2.safetensors",
  "SOAP_LoRA.safetensors",
  "more_details.safetensors",
  "HandFineTuning_XL.safetensors",
  "kFeetMix101_v2-000006.safetensors",
  "dresm_lora.safetensors",
  "dresmlina.safetensors",
  "dresmvela.safetensors",
  "libawomandresm.safetensors",
  "Model_liora.safetensors",
  "dresmzayna.safetensors",
  "dresmkimz.safetensors",
  "dresmlara.safetensors",
  "dresmlumi.safetensors",
  "dresmrhys.safetensors",
  "dresmanya.safetensors",
  "dresmdubois.safetensors",
  "dresmelsa.safetensors",
  "dresmavalon.safetensors",
  "dresmpimrada.safetensors",
  "dresmnara.safetensors",
  "dresmpimjai.safetensors",
  "dresmrizal.safetensors",
  "dresmava.safetensors",
  "dresmreena.safetensors",
  "dresmaradha.safetensors",
  "dresmisabela.safetensors",
  "dresmsofia.safetensors",
  "dresmcamila.safetensors",
  "dresmmariana.safetensors",
  "dresmjuliana.safetensors",
  "dresmbeatriz.safetensors",
  "dresmraquel.safetensors",
  "dresmnia.safetensors",
  "dresmdevon.safetensors",
  "dresmted.safetensors",
  "dresmkenji.safetensors",
  "dresmmaria.safetensors",
  "dresmlee.safetensors",
  "dresmlin.safetensors",
  "dresmwomhands.safetensors",
  "dresmclara.safetensors",
  "dresmlavanya.safetensors"
];
